import _ from 'lodash';
import { Form, Select } from 'antd';
import { WrappedFormUtils } from 'antd/lib/form/Form';
import React from 'react';

const { Option } = Select;

interface Props {
  form: WrappedFormUtils;
  payors: {
    id: string;
    name: string;
  }[];
  onChange: () => void;
}

export default class InsurancePayorField extends React.Component<Props, {}> {
  render(): JSX.Element {
    const { getFieldDecorator } = this.props.form;

    return (
      <Form.Item label="Select the insurance carrier">
        {getFieldDecorator('carrier', {
          rules: [
            {
              required: true,
              message: 'Required',
            },
          ],
        })(
          <Select
            disabled={this.props.payors.length === 0}
            showSearch
            dropdownMatchSelectWidth={false}
            placeholder="Insurance Carrier"
            optionFilterProp="children"
          >
            {_.sortBy(this.props.payors, ['name']).map(payor => (
              <Option value={payor.id} key={payor.id}>
                {payor.name}
              </Option>
            ))}
          </Select>
        )}
      </Form.Item>
    );
  }
}
